import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type { FeatureFlags } from "./types";

export async function getFeatureFlags(): Promise<FeatureFlags> {
  const payload = await apiFetch<Partial<FeatureFlags>>(
    ENDPOINTS.featureFlags.list,
  );

  return {
    feature_super_quotation_manual_mode:
      payload.feature_super_quotation_manual_mode ?? false,
    feature_quotation_export_report:
      payload.feature_quotation_export_report ?? true,
  };
}
